import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { BatchSummaryDto } from "~/types/api";

type AdminBatchesState = {
  page: number;
  searchText: string;
  selectedBatch: BatchSummaryDto | null;
  toteSearch: string;
  sidePanelOrderId: Guid | null;
};

const initialState: AdminBatchesState = {
  page: 1,
  searchText: "",
  selectedBatch: null,
  toteSearch: "",
  sidePanelOrderId: null
};

export const adminBatchesSlice = createSlice({
  name: "adminBatches",
  initialState,
  reducers: {
    resetSelectedBatch(state) {
      state.selectedBatch = null;
    },
    selectBatch(state, { payload }: PayloadAction<BatchSummaryDto>) {
      state.selectedBatch = payload;
    },
    setPage(state, { payload }: PayloadAction<number>) {
      state.page = payload;
    },
    setSearchText(state, { payload }: PayloadAction<string>) {
      state.searchText = payload;
    },
    setToteSearch(state, { payload }: PayloadAction<string>) {
      state.toteSearch = payload;
    },
    setSidePanelOrderId(state, { payload }: PayloadAction<Guid | null>) {
      state.sidePanelOrderId = payload;
    }
  }
});
export const {
  resetSelectedBatch,
  selectBatch,
  setPage,
  setSearchText,
  setToteSearch,
  setSidePanelOrderId
} = adminBatchesSlice.actions;
